import config from "../config";
export default async function sendStats(customer_id, total, searchText, hash , isSuccess, productUrl) {
    try {
        var searchParams = new URLSearchParams();
        searchParams.set('user', customer_id);
        searchParams.set('query', searchText);
        searchParams.set('hash', hash);
        searchParams.set('results', total);
        productUrl ?
            searchParams.set('productUrl', productUrl) :
            searchParams.set('productUrl', '')
        searchParams.set('isSuccess', isSuccess);

         const url = config.url + '/api/site/reportStats?' + searchParams.toString();
         const response = await fetch(url);
    } catch (error) {
        console.log(error)
    }

}